import { db } from "../../utils/firebase";

export const getAllPeople = async () => {
  const result = {
    faculty: [],
    budget: [],
    study: [],
    postdoc: [],
    phd: [],
    bme: [],
    visitor: [],
    leave: [],
    master: [],
    undergrad: [],
    viterbi_summer: [],
    viterbi_curve: [],
    viterbi_fellow: [],
    urap: [],
    reu: [],
    sure: [],
    k12: [],
    webmaster: [],
  };

  const querySnapshot = await db.collection("people").get();
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    const person = doc.data();
    const { title } = person;
    person.id = doc.id;
    if (title) {
      if (Array.isArray(title)) {
        title.forEach((element) => result[element].push(person));
      } else {
        result[title].push(person);
      }
    }
  });

  // sort each section's people in alphabetic order
  for (const key in result) {
    result[key].sort((a, b) => {
      // get first name for a
      let aIndex = 0;
      for (let i = a.name.length - 1; i >= 0; --i) {
        if (a.name[i] === " ") {
          aIndex = i + 1;
          break;
        }
      }
      const fnameA = a.name.slice(aIndex);

      // get first name for b
      let bIndex = 0;
      for (let i = b.name.length - 1; i >= 0; --i) {
        if (b.name[i] === " ") {
          bIndex = i + 1;
          break;
        }
      }
      const fnameB = b.name.slice(bIndex);

      if (fnameA < fnameB) return -1;
      else if (fnameA > fnameB) return 1;
      return 0;
    });
  }

  return result;
};

// get one single people
export const getPersonById = async (id) => {
  const doc = await db
    .collection("people")
    .doc(id)
    .get();
  const { audio, name, description, photo, title, website, projects } = doc.data();
  console.log(doc.data())
  return { audio, name, description, photo, title, website, projects };
};
